import { api } from '../api/client';
import type { BulkAddListItemsRequest, BulkAddListItemsResponse } from '@familyhub/shared';

/**
 * Send named items to the groceries list via the groceries bulk endpoint.
 *
 * This is the cross-module seam: the recipes module calls a groceries URL with
 * shared shapes and imports nothing from the groceries module. It is online-only,
 * like the compare and selection actions — a deliberate at-home action, not
 * something the offline outbox carries.
 */
export function addToShoppingList(
  items: BulkAddListItemsRequest['items'],
): Promise<BulkAddListItemsResponse> {
  return api<BulkAddListItemsResponse>('/api/v1/list/items/bulk', {
    method: 'POST',
    body: { items },
  });
}
